import { Notify } from 'quasar'

export default {
  // 下載文件
  downloadFile(fileBlob, fileName) {
    let blob, objectURL

    blob = new Blob(fileBlob)
    objectURL = window.URL.createObjectURL(blob)

    if (navigator.appVersion.toString().indexOf('.NET') > 0) {
      window.navigator.msSaveOrOpenBlob(blob, fileName)
    } else {
      let link = document.createElement('a')
      link.href = objectURL
      link.download = fileName
      document.body.appendChild(link)
      Notify.create({
        type: 'positive',
        message: '匯出成功'
      })
      link.click()
      link.remove()
    }
  },
  // 獲取文件類型
  dataUrlType(url) {
    let fileType = {
      image: ['png', 'jpg', 'jpeg'],
      video: ['mp4']
    }

    let fileExtension

    if (url.includes('data:')) {
      fileExtension = url.split(';')[0].split(':')[1].split('/')[1]
    } else {
      fileExtension = url.split('.').pop()
    }

    for (let type in fileType) {
      if (fileType[type].indexOf(fileExtension) >= 0) {
        return type
      }
    }
    return null
  },

  // 下載pdf文件
  downloadPdf(dom, title, size) {
    const JsPDF = require('jspdf').default
    const html2Canvas = require('html2canvas')
    html2Canvas(dom, {
      // html2Canvas(document.querySelector('#FilePdfDom'), { //这是在界面上设置一个id
      //只下载id为pdfDom的内容
      // html2Canvas(document.body, { //body是下载整个界面
      useCORS: true, //是否尝试使用CORS从服务器加载图像
      allowTaint: true,
      dpi: 300, //解决生产图片模糊
      scale: 3 //清晰度--放大倍数
      // width: 490, //canvas宽度
      // height: 240 //canvas高度
      // x: 0, //x坐标
      // y: 0, //y坐标
      // async: false, //是否异步解析和呈现元素
      // foreignObjectRendering: true, //是否在浏览器支持的情况下使用ForeignObject渲染
    }).then(function (canvas) {
      let PDF = new JsPDF('', 'pt', 'a4')
      // 圖片來自 html 寬度
      const sourceWidth = canvas.width
      // 圖片來自 html 高度
      const sourceHeight = canvas.height
      // 實際要放入 PDF 的寬度
      const actualWidth = (size * 595) / 21
      // 加入圖片至 PDF
      PDF.addImage(canvas.toDataURL('image/jpeg', 1.0), 'JPEG', 0, 0, actualWidth, sourceHeight * (actualWidth / sourceWidth))
      PDF.save(title + '.pdf')
    })
  },

  // 下載可分頁固定大小的a4 pdf
  downloadA4Pdf(dom, title, margin) {
    const JsPDF = require('jspdf').default
    const html2Canvas = require('html2canvas')

    let PDF = new JsPDF('', 'pt', 'a4')
    const A4_HEIGHT = 841.89
    const A4_WIDTH = 595.28
    const WIDTH_MARGIN = margin
    const HEIGHT_MARGIN = margin
    const pageHeight = A4_HEIGHT - 2 * HEIGHT_MARGIN
    const A4_WIDTH_PX = 1123 // A4 寬度(px)

    const clone = dom.cloneNode(true)
    const container = document.createElement('div')
    container.style.width = A4_WIDTH_PX + 'px'
    container.style.position = 'absolute'
    container.style.left = '-9999px' // 把容器移出螢幕外，讓它不會干擾畫面但仍能被渲染
    container.style.top = '0'
    container.style.zIndex = '-1' // 保險用，避免不小心蓋住畫面上其他元素。
    container.appendChild(clone) // 把複製的DOM放進隱藏容器裡
    document.body.appendChild(container) // 把DOM加進body，否則html2canvas抓不到(因為還沒進入DOM tree）

    html2Canvas(container, {
      allowTaint: true,
      useCORS: true,
      scale: 4 * (1 / window.devicePixelRatio) // 維持縮放比例
    }).then(function (canvas) {
      document.body.removeChild(container) // 已擷取完，將container拿掉

      const canvasWidth = canvas.width
      const canvasHeight = canvas.height
      const imgWidth = A4_WIDTH - 2 * WIDTH_MARGIN
      const imgHeight = (imgWidth / canvasWidth) * canvasHeight
      let position = HEIGHT_MARGIN
      let heightUnprinted = imgHeight // need multi page pdf

      if (imgHeight < pageHeight) {
        PDF.addImage(canvas.toDataURL('image/jpeg', 1.0), 'JPEG', WIDTH_MARGIN, HEIGHT_MARGIN, imgWidth, imgHeight)
      } else {
        while (heightUnprinted > 0) {
          PDF.addImage(canvas.toDataURL('image/jpeg', 1.0), 'JPEG', WIDTH_MARGIN, position, imgWidth, imgHeight)
          PDF.setFillColor(255, 255, 255)
          PDF.rect(0, 0, A4_WIDTH, HEIGHT_MARGIN, 'F') // margin top
          PDF.rect(0, A4_HEIGHT - HEIGHT_MARGIN, A4_WIDTH, HEIGHT_MARGIN, 'F') // margin bottom

          heightUnprinted -= pageHeight
          position -= pageHeight // next vertical placement
          // add another page if there's more contents to print
          if (heightUnprinted > 0) PDF.addPage()
        }
      }
      PDF.save(title + '.pdf')
    })
  },

  // 下载文件(不需请求api)
  async getFiles(url, name) {
    try {
      //发起网络请求
      const response = await fetch(url)
      if (!response.ok) {
        throw new Error(`网络响应错误: ${response.statusText}`)
      }
      //创建一个指向文件URL的Blob对象
      const blob = await response.blob()
      //创建一个隐藏的<a>标签用于下载
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = window.URL.createObjectURL(blob)
      a.download = name
      //将<a>标签添加到文档中并触发点击
      document.body.appendChild(a)
      //触发点击事件以下载文件
      a.click()
      //下载成功的提示信息
      Notify.create({
        type: 'positive',
        message: '下載成功！',
        timeout: 1000
      })
      //下载完成后，释放URL对象占用的内存，并移除a标签
      window.URL.revokeObjectURL(a.href)
      document.body.removeChild(a)
    } catch (error) {
      console.error('下载文件时出错:', error)
      alert('下载文件时出错，请稍后再试。')
    }
  },

  //base64转文件流
  dataURLtoBlob(base64, format) {
    let bstr = atob(base64)
    let n = bstr.length
    let u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new Blob([u8arr], { type: `application/${format}` })
  },

  async base64toUrl(base64) {
    if (!base64) return
    return await new Promise((resolve) => {
      const img = new Image()
      img.crossOrigin = 'Anonymous'
      img.src = base64
      img.onload = () => {
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')
        canvas.width = img.width
        canvas.height = img.height
        context.drawImage(img, 0, 0)
        const imageURL = canvas.toDataURL('image/png')
        resolve(imageURL)
      }
    })
  }
}
